import { bookingsStore, configStore, entityStore, EntityV2Store, loginStore } from "../state/CommonState"
import MonApi, { GET_BOOKINGDSR_BY_FILTER_URI, GET_CENTRAL_OPERATIONS_AGUSERS_URI, GET_MYACTIONS_LIST_URI, GET_MYACTIONS_PAYMENT_DETAILS_PENDING_URI, GET_MYACTIONS_SHIPPING_INSTRUCTIONS_PENDING_URI, GET_SH_ENTITIES_SORTED_BY_NAME_URI, GET_WEBHOOKS_BY_FILTER_URI, INSERT_ONE_MYACTION_URI, REMOVE_MYACTIONS_BY_BOOKING_NUMBER_AND_STATUS_URI, REMOVE_MYACTIONS_BY_ID_URI, REPLACE_BOOKING_URI, REPLACE_MYACTION_URI, UPDATE_ENTITY_BY_ID_URI } from '../state/mongo-api';
import Newapi from "../state/new-api"
import Utils from "../util/Utils"
import { validateFileApproval } from "./task-file-approval"
import { taskStore } from "./task-store"
import Api from "../state/Api"
import QuoteCalcV2 from "../util/quote-calc-v2"
import { WEBHOOKTYPES } from "../util/constants"
import TenantUtils from "../util/tenant.utils"


class Task {
    initialize(booking, entity) {
        this.bookingNum = booking._id
        this.customerRefNum = booking?.contract?.customerReferenceNum
        this.origin = booking.contract?.origin
        this.destination = booking.contract?.destination
        this.shipmentType = booking.contract?.shipmentType
        this.shipmentScope = booking.contract?.shipmentScope
        this.por = booking.contract?.portOfReceipt
        this.pol = booking.contract?.portOfLoading
        this.fpod = booking.contract?.finalPlaceOfDelivery
        this.pod = booking.contract?.portOfDischarge
        this.reworkingPort = booking.contract?.reworkingPort
        this.entityCountry = entity.entityCountry
        this.entityId = booking.contract?.entityId
        this.entityName = entity.entityName
        this.branchId = booking?.branchId
        for (let i = 2; i < 6; i++) {
            if(booking.contract["destination"+i]!=undefined && booking.contract["destination"+i].length>0){
                this["destination"+i] = booking.contract["destination"+i]
            }
        }
    }
    constructor(actionName) {
        console.log('CREATING NEW TASK', actionName)
        this._id = ''
        this.actionName = actionName
        this.stage = 0
        this.files = []
        this.original_file = []
        this.isValid = true
        this.isValidfield = []
        this.dueDate = ''
        this.dueTime = ''
        this.bookingNum = ''
        this.customerRefNum = ''
        this.origin = ''
        this.destination = ''
        this.shipmentType = ''
        this.shipmentScope = ''
        this.por = ''
        this.pol = ''
        this.fpod = ''
        this.pod=''
        this.reworkingPort=''
        this.entityCountry = ''
        this.entityId = ''
        this.branchId=''
        this.entityName = ''
        this.status = 'PENDING'
        this.pendingWith = 'CUSTOMER'
        this.createdOn = Date.now()
        this.updatedOn = Date.now()
        this.createdBy = loginStore.email
        this.completedOn = ''
        this.completedBy = ''
        this.customerStatus = 'PENDING'
        this.customerCompletedBy = ''
        this.customerCompletedOn = ''
    }
}
export default class Taskapi {
    static async getNextNum() {
        let ret = await MonApi.nextnum('myactions')
        return ret.nextNum
    }
    static async saveTask(task,bookingID="") {
        // if(taskStore.current.actionName != 'Request for Booking Cancellation'){
        //     taskStore.setModalMessage('Triggering Action')
        // }
        let actionNames=['Shipping Bill Checklist Approval','Commercial Invoice & Packing List Pending','Bill of Entry Checklist Approval','BL Draft Approval','Shipping Instructions (FCL)','Carting Order','Carrier Release Order',
            'Other Actions (FCL)','Other Actions (LCL)','Other Actions (Air)','Entry Summary Approval','Upload Measurement Slip','POD Procurement',
            'Invoice Acceptance', 'Booking Amendment'
        ]

        taskStore.triggerActionVisible = false
        let booking = { ...bookingsStore.current }
        let nextNum = await Taskapi.getNextNum()
        if(bookingID.trim().length==0){
            task._id = {
                bookingNum: booking._id,
                num: nextNum
            }
        }else{
            task._id = {
                bookingNum: bookingID,
                num: nextNum
            }
        }
        task.updatelist = [
            {
                updatedOn:Date.now(),
                updatedBy:loginStore.email,
                status:"created"
            }
        ]
        if(booking?.blockbooking){
            task.blockbooking = true;
        }
        //task.initialize(booking)
        console.log(" the task insisde save task is ",task.actionName);
        task.bookingNum = task._id.bookingNum;
        if(task.actionName === 'BL Draft Approval'){
            const pendingAction  = await MonApi.apost(GET_MYACTIONS_SHIPPING_INSTRUCTIONS_PENDING_URI, {})
              if(pendingAction && pendingAction.length > 0 && pendingAction[0]?._id?.num != undefined){
                await MonApi.apost(REMOVE_MYACTIONS_BY_ID_URI, {
                  num: pendingAction[0]._id.num
                })
              }              
        }
        let ret = await MonApi.apost(INSERT_ONE_MYACTION_URI, task)
        if(task.actionName == 'Carrier Release Order'){
            Api.triggerblTypeAction(task.bookingNum,"cro")
        }
        if(task?.financeInformation?.length > 0){
            await Api.updateFinanceInformation(task.entityId,task.financeInformation)
        }
        if (ret.error) {
            taskStore.setModalMessage('Error in triggering action. *** ' + ret.error)
        } else {
            taskStore.current = task
            let actName = taskStore.current.actionName
            const stopEmails = ['Booking Amendment', 'Cost Adjustment Approval']
            if (stopEmails.includes(taskStore.current.actionName) && TenantUtils.isNavexel()) return
            if(taskStore.current.actionName == 'Update Cost' || taskStore.current.actionName == "Visibility Update"){
                Taskapi.sendActionAgragaTriggerEmail()
                taskStore.setModalEnd('My Action has been triggered and mail sent successfully.')
            }else{
                if(taskStore.current.actionName == 'Request for Booking Cancellation'){
                    Taskapi.sendActionAgragaTriggerEmail()
                }
                if(taskStore.current.actionName != 'Request for Booking Cancellation' && taskStore.current.actionName !== 'Additional Document Request' && 
                !actionNames.includes(taskStore.current.actionName)
                ){
                    Taskapi.sendActionTriggerEmail()
                    taskStore.setModalEnd('My Action has been triggered and mail sent successfully.')
                }else{
                    if(actionNames.includes(taskStore.current.actionName)){
                        Taskapi.sendActionTriggerMail()
                        taskStore.setModalEnd('My Action has been triggered and mail sent successfully.')
                    }else{
                        taskStore.setModalEnd('My Action has been triggered successfully.')
                    }
                }
            }
        }
    }
    static async saveTaskRequestCancellation(task,bookingID="",booking) {
        taskStore.triggerActionVisible = false
        let nextNum = await Taskapi.getNextNum()
        if(bookingID.trim().length==0){
            task._id = {
                bookingNum: booking._id,
                num: nextNum
            }
        }else{
            task._id = {
                bookingNum: bookingID,
                num: nextNum
            }
        }
        task.updatelist = [
            {
                updatedOn:Date.now(),
                updatedBy:loginStore.email,
                status:"created"
            }
        ]
        if(booking?.blockbooking){
            task.blockbooking = true;
        }
        //task.initialize(booking)
        console.log(" the task insisde save task is ",task.actionName);
        task.bookingNum = task._id.bookingNum;
        let ret = await MonApi.apost(INSERT_ONE_MYACTION_URI, task)
        if (ret.error) {
            taskStore.setModalMessage('Error in triggering action. *** ' + ret.error)
        } else {
            taskStore.current = task
        }
    }
    static async saveTaskForEnablingMarineInsurance(task,bookingID="") {
        console.log("123456");
        // if(taskStore.current.actionName != 'Request for Booking Cancellation'){
        //     taskStore.setModalMessage('Triggering Action')
        // }

        taskStore.triggerActionVisible = false
        let booking = { ...bookingsStore.current }
        let nextNum = await Taskapi.getNextNum()
        if(bookingID.trim().length==0){
            task._id = {
                bookingNum: booking._id,
                num: nextNum
            }
        }else{
            task._id = {
                bookingNum: bookingID,
                num: nextNum
            }
        }
        task.updatelist = [
            {
                updatedOn:Date.now(),
                updatedBy:loginStore.email,
                status:"created"
            }
        ]
        //task.initialize(booking)
        console.log(" the task insisde save task is ",task.actionName);
        console.log(" the task is ",task)
        task.bookingNum = task._id.bookingNum;
        let ret = await MonApi.apost(INSERT_ONE_MYACTION_URI, task)
        if(task?.financeInformation?.length > 0){
            await Api.updateFinanceInformation(task.entityId,task.financeInformation)
        }
        if (ret.error) {
            taskStore.setModalMessage('Error in triggering action. *** ' + ret.error)
        } else {
            taskStore.current = task
            if(taskStore.current.actionName != 'Request for Booking Cancellation' && taskStore.current.actionName !== 'Additional Document Request'){
                await Taskapi.sendActionTriggerEmail()
            }
            //taskStore.setModalEnd('Action triggered successfully.')
        }
    }
    static async updateTask(task) {
        let u = {
            updatedOn:Date.now(),
            updatedBy:loginStore.email,
            status:task.lastview
        }
        if(loginStore.isClient()){
            u['status'] = 'CUSTOMER'
        }else{
            u['status'] = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
        }
        if(task.updatelist==undefined){
            task.updatelist = [u]
        }else{
            task.updatelist.push(u)
            task.updatelist.sort((a,b)=>{
                return b.updatedOn - a.updatedOn
            })
        }
        if(task.actionName=='Carting Order' && task.stage==2){
            let d1 = await MonApi.apost(GET_WEBHOOKS_BY_FILTER_URI, {
  entityId: task.entityId,
  type: WEBHOOKTYPES.MYCARTINGORDER
})
            if(d1.length>0){
                try {
                    let d = {
                        _id:task.bookingNum,
                        data:{},
                        tsCreatedOn:Date.now()
                    }
                    for (let i = 0; i < task.co_data.length; i++) {
                        let v = task.co_data[i]
                        if(v[v.label]!=undefined && v[v.label].trim().length!=0){
                            d.data[v.label] = v[v.label]
                        }
                    }
                    d.data['response_type'] = WEBHOOKTYPES.MYCARTINGORDER
                    const response = await fetch(d1[0]['webhook_url'], {
                        method: 'post',
                        body: JSON.stringify(d),
                        headers: {'Content-Type': 'application/json'}
                    });
                    const data1 = await response.json();
                    console.log(data1,WEBHOOKTYPES.MYCARTINGORDER,d)
                } catch(error) {
                    console.log(error)
                }
            }
        }
        console.log(task)
        let ret = {error:false}
        if(["Commercial Invoice & Packing List Pending","BL Draft Approval","AWB Draft Approval","Shipping Instructions (LCL)","Shipping Instructions (Air)","Shipping Instructions (FCL)"].indexOf(task.actionName)!=-1){
            ret = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/myactions/autotrigger`,task)
        }else{
            ret = await MonApi.apost(REPLACE_MYACTION_URI, task)
        }
        if (ret.error) {
            configStore.setModalMessage('Error in triggering action. *** ' + ret.error)
        } else {
            if (task.actionName == 'Cost Adjustment Approval' && TenantUtils.isNavexel()) return
            if(task.actionName == 'Request for Booking Cancellation' && task.status == 'COMPLETED' && task.bookingNum != undefined) await MonApi.apost(REMOVE_MYACTIONS_BY_BOOKING_NUMBER_AND_STATUS_URI, {
              bookingNum: task.bookingNum,
              status: 'PENDING'
            })
            if(!task.yetToSubmitted){
                if(task.pendingWith == 'CUSTOMER' && task.status!="COMPLETED"){
                    let reuploadActions = ['Shipping Bill Checklist Approval','Bill of Entry Checklist Approval','BL Draft Approval','Entry Summary Approval','Invoice Acceptance','Commercial Invoice & Packing List Pending','Booking Amendment']
                    if(task.actionName == 'Booking Amendment' && TenantUtils.isAgraga()){
                       Taskapi.sendActionTriggerMail()
                    }else{
                        if(task.actionName == 'Booking Amendment' && TenantUtils.isNavexel()) return 
                        if(reuploadActions.includes(task.actionName) && taskStore.current.files.some((e)=>e.approved == 'Reject')){
                            Taskapi.sendActionTriggerMail()
                        }else{
                            Taskapi.sendActionTriggerEmail()
                        }
                    }
                }else{
                    if(task.actionName == 'Booking Amendment' && TenantUtils.isNavexel()) return 
                    let at = [
                        "Delay in Delivery Order release",
                        "Carting Order",
                        "Carrier Release Order",
                        "Airline Release Order",
                        "Stuffed Container Hand-over Pending",
                        "Customs Cleared Cargo Hand-over Pending",
                        "Empty Container Pick-up Pending",
                        "Delay in Pick-up at Destination",
                        "Empty Container Return to Carrier Pending",
                        "DO Release (Ocean)",
                        "DO Release (Air)",
                        "Visibility Update"
                    ]
                    let approvalMailNotSend = ['Shipping Bill Checklist Approval','Bill of Entry Checklist Approval','IGM Manifest Details','Commercial Invoice & Packing List Pending','Additional Document Request','VGM Declaration','Booking Amendment']
                    if(approvalMailNotSend.includes(task.actionName) && task.status == 'COMPLETED'){
                       at.push(task.actionName)
                    }
                    if(((task.updatelist[0]['updatedBy'].toLowerCase().indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)==-1 || task.updatelist[0]['updatedBy'].toLowerCase().indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) > 0) && at.indexOf(task.actionName)==-1) || (task.status == 'COMPLETED' && task.actionName == 'Invoice Acceptance') || task.status!="COMPLETED" ){
                        Taskapi.sendActionAgragaTriggerEmail()
                    }
                    if(TenantUtils.isAgraga() && task.actionName=='Booking Amendment' && task.status == 'COMPLETED' && task.customerStatus == 'PENDING'){
                      Taskapi.sendActionTriggerMail()
                    }
                }
            }else{
                if(task.actionName === "Shipping Bill Checklist Approval" || task.actionName === "BL Draft Approval" ||task.actionName == 'Entry Summary Approval' ){
                    Taskapi.sendActionTriggerMail()
                }
            }
        }
    }
    static async getTaskList() {
        let filter = {}
        if (loginStore.isClient()) filter = { 'gst': configStore.currentSelectedEntity.gst }
        let ret = await MonApi.apost(GET_MYACTIONS_LIST_URI, filter)
        console.log('result =', ret)
        return ret
    }
    static async getTaskCopy(task) {
        let filter = {_id: task._id}
        let ret = await MonApi.apost(GET_MYACTIONS_LIST_URI, filter)
        const response = await Api.getFinanceDetails(ret[0].entityId)
        if (response?.financeInformation?.length > 0) {
            ret[0].financeInformation =  response?.financeInformation
        }
        return ret
    }
    static async getTaskForAction(bookingNum, action, num="") {
        let bNum = (bookingNum || "").trim()
        let aName = action || ""
        let filter = {
            $or: [
                { '_id.bookingNum': bNum },
                { 'bookingNum': bNum }
            ],
            actionName: aName
        }
        if (num !== "" && num !== undefined && num !== null) {
            let parsedNum = !isNaN(Number(num)) ? Number(num) : num
            filter = {
                $or: [
                    { '_id.bookingNum': bNum, '_id.num': parsedNum },
                    { '_id': { bookingNum: bNum, num: parsedNum } },
                    { 'bookingNum': bNum, '_id.num': parsedNum }
                ],
                actionName: aName
            }
        }
        let ret = await MonApi.apost(GET_MYACTIONS_LIST_URI, filter)
        if ((!Array.isArray(ret) || ret.length === 0) && num !== "" && num !== undefined && num !== null) {
            let fallbackFilter = {
                $or: [
                    { '_id.bookingNum': bNum },
                    { 'bookingNum': bNum }
                ],
                actionName: aName
            }
            ret = await MonApi.apost(GET_MYACTIONS_LIST_URI, fallbackFilter)
        }
        return Array.isArray(ret) ? ret : []
    }
    static async getTasklist4Booking(bookingNum) {
        let filter = { 'bookingNum': bookingNum }
        if (loginStore.isClient()) filter['gst'] = configStore.currentSelectedEntity.gst
        let ret = await MonApi.apost(GET_MYACTIONS_LIST_URI, filter)
        console.log('result =', ret)
        return ret
    }
    static async replaceBooking(booking) {
        delete booking.Entities
        delete booking.Branches
        delete booking.Bookings
        delete booking.Credit
        if(booking.contract.quoteValue==undefined || Utils.toNum(booking.contract.quoteValue)==0 || booking.contract.quoteValue.toString().trim()==""){
            let k = new QuoteCalcV2(booking.contract).recalc()
            booking.contract.quoteValue =  k.quoteValue
            booking.contract.quoteValueUSD = k.quoteValueUSD
        }
        let ret = await MonApi.apost(REPLACE_BOOKING_URI, booking)
        if (ret.error) {
            configStore.setModalMessage('Error in saving revised schedule. *** ' + ret.error)
            return false
        } else {
            //configStore.setModalMessage('Action updated successfully.')
        }
        return true
    }
    static async genPdf(task, fieldMapping) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/pdfgen/vgmdeclaration/${task.bookingNum}`
        let rows = []
        let index = 1
        Object.keys(fieldMapping).map(e => {
            let row = [index]
            row.push(fieldMapping[e])
            row.push(task[e])
            rows.push(row)
            index++
        })
        let ret = await MonApi.apost(url, rows)
        //console.log('RETURN FROM PDFGEN = ', ret)
        return ret
    }
    static async genvgmdecl(task, fieldMapping) {
        let containers = Object.keys(task.data)
        for (let i = 0; i < containers.length; i++) {
            let container = containers[i]
            let approved = ''
            task.files.map((k)=>{
                if(k.label == container){
                    approved = k.approved
                }
            })
            if(approved.length==0 || approved=='Reject'){
                let data = task.data[container]
                let url = `${process.env.REACT_APP_API_SERVER}/api/v1/pdfgen/vgmdeclaration/${task.bookingNum}/${i}`
                let rows = []
                let index = 1
                if(containers.hazType=='Hazardous'){
                    fieldMapping['imdgClass'] = 'IMDG Class'
                    fieldMapping['packingGroup'] = 'Packing Group'
                    // fieldMapping['unno'] = 'UN No.'
                    fieldMapping['unnumber'] = 'unnumber'
                }
                Object.keys(fieldMapping).map(e => {
                    let row = [index]
                    row.push(fieldMapping[e])
                    if(fieldMapping[e]=="Weighment Time"){
                        if(task.version_v2!=undefined && task.version_v2==true){
                            row.push(`${data["wbTimehh"]}:${data["wbTimemm"]}:${data["wbTimeAP"]}`)
                        }else{
                            row.push(data[e])
                        }
                    }else{
                        row.push(data[e])
                    }
                    rows.push(row)
                    index++
                })
                let ret = await MonApi.apost(url, rows)
                for (let j = 0; j < task.files.length; j++) {
                    if(task.files[j].label.replace(' - VGM Declaration','')==container){
                        task.files[j].filename = ret.key.filename
                        task.files[j].approved = "Approve"
                    }
                }
                console.log('RETURN FROM PDFGEN = ', container, ret)
            }

        }
    }
    static async genSIinstructions_air(task) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/pdfgen/shippinginstructions/${task.bookingNum}`
        let ret = await MonApi.apost(url, task)
        console.log('RETURN FROM PDFGEN = ', ret)
        return ret
    }
    static async genSIinstructions_fcl(task) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/pdfgen/shippinginstructionsfcl/${task.bookingNum}`
        let ret = await MonApi.apost(url, task)
        console.log('RETURN FROM PDFGEN = ', ret)
        return ret
    }
    static async genSIinstructions_lcl(task) {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/pdfgen/shippinginstructionslcl/${task.bookingNum}`
        let ret = await MonApi.apost(url, task)
        console.log('RETURN FROM PDFGEN = ', ret)
        return ret
    }
    static async saveEntity() {
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/entity`
        let ret = await MonApi.apost(url, entityStore.entityRec, 'PUT')
        return ret
    }
    static async setEntityVgmDetails(entityId, vgm) {
        console.log('UPDATING ENTITY VGM', entityId, vgm)
        let ret = await MonApi.apost(UPDATE_ENTITY_BY_ID_URI, {
  _id: entityId,
  vgm
})
        console.log(ret)
    }
    static async getEmailsCenterlOperations(entityId,hazardous) {
        let ret = await MonApi.apost(GET_CENTRAL_OPERATIONS_AGUSERS_URI, {
            status: "ACTIVE",
            department: "Central Operations",
  entityId: entityId,
  hazardous: hazardous
})
        return ret
    }
    static async sendActionTriggerEmail() {
        if(taskStore.current && taskStore.name && taskStore.name.trim().length>0){
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/sendclientactionmail`
        let data = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/listuserIds`, {entityId:taskStore.current.entityId,branchId:bookingsStore.current.branchId})
            let customer = data?.shEntitiesCustomer[0]?.customer;
             let b = bookingsStore.current
            let cc = Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b?.contract.nomination);
            let userlist = Utils.getCustomerService(customer,taskStore.current.createdBy)
            let from = `Actions ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} ${process.env.REACT_APP_MYACTIONSEMAIL_ID.split('@')[0]+'@'+process.env.REACT_APP_ENTERPRISE_DOMAIN}>`
            let to = bookingsStore.current.blockbooking ? undefined : data.entityUserIdList.join(',')
            let subject = taskStore.current.bookingNum + ' // ' + taskStore.name
            if(customer?.crossBorder?.salesVertical?.trim() == 'MSME' && b?.contract?.customerReferenceNum) subject = subject+'// CRN: '+ b?.contract?.customerReferenceNum
            let message = `
        <p>We have a new Action for you!</p>
        <p>Please <strong><a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${taskStore.name}">Click Here</a></strong> to view and complete</p>
        <br/><br/>
        <p>Thank You</p>
        <p><strong>Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</strong></p>`  
        // if(taskStore.name === 'Payment Details' && taskStore.current.isFullPayment === 'Yes'){
        //     let operations = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/common/executequery/Agusers`,{filter:{department:'',status:'ACTIVE'},project:{email:1}})
        //     to = operations.map(e=>e.email).join(",")
        // }  
            //configStore.setModalMessage('Sending Email ...')
            const doc = {
                from, to, cc, subject, message, userlist,bookingNum:taskStore.current.bookingNum
            }
            if (!to) {
                if(Array.isArray(cc)){
                    doc.to = cc.join(',');
                }else{
                    doc.to = cc;
                }                
                doc.cc = '';
            }
            if(!to && !cc){
                to = `pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`
              }
            let ret
        try{    
                if (doc.to){
                ret = await MonApi.apost(url, doc)
                }
        }catch(e){
                console.log('ERROR IN SENDING MAIL', e)
            }
        console.log('return from sending mail=',ret)
            //configStore.setModalMessage(`Email sent to ${ret.message.accepted}`)
        }
    }
    static async sendActionTriggerMail() {
        if(taskStore.current && taskStore.name && taskStore.name.trim().length>0){
            let b = bookingsStore.current
            let branch = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/branch/${b.branchId}`)
            let country = ""
            if(branch.data){
                country = branch.data.country.toLowerCase()
            }
            let data = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/listuserIds`, {entityId:taskStore.current.entityId,branchId:bookingsStore.current.branchId})
            let customer = data?.shEntitiesCustomer[0]?.customer;
            let cc = Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b?.contract?.nomination );
            let from = `Actions ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} ${process.env.REACT_APP_MYACTIONSEMAIL_ID.split('@')[0]+'@'+process.env.REACT_APP_ENTERPRISE_DOMAIN}>`
            let to = bookingsStore.current.blockbooking ? undefined : data.entityUserIdList.join(',')
            if(taskStore.current.actionName == 'Booking Amendment' && taskStore.current.pendingWith !== 'CUSTOMER' && taskStore.current.status !== 'COMPLETED'){
            let por = b.contract.portOfReceipt.toLowerCase()
            let fpod = b.contract.finalPlaceOfDelivery.toLowerCase()
            if (b.contract.shipmentType === 'AIR') {
                por = b.contract.originAirport.toLowerCase()
                fpod = b.contract.destinationAirport.toLowerCase()
            }
                let imp_exp = ''
                if(country.trim().length>0){
                if (por.indexOf(country) >= 0) imp_exp = 'Export'
                else if (fpod.indexOf(country) >= 0) imp_exp = 'Import'
            }
                let co = await Taskapi.getEmailsCenterlOperations(taskStore.current.entityId, b.contract.hazardous)
                let toIds = []
                for (let i = 0; i < co.length; i++) {
                    if(taskStore.current.shipmentType.toLowerCase().indexOf('air')!=-1){
                        if(
                        (co[i]['role'].indexOf('Air export Coordination') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                        (co[i]['role'].indexOf('Air Import Coordination') != -1 && (imp_exp=="" || imp_exp=="Import")) ||
                        (co[i]['role'].indexOf('Air export Documentation') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                        (co[i]['role'].indexOf('Air Import Documentation') != -1 && (imp_exp=="" || imp_exp=="Import"))){
                            toIds.push(co[i]["_id"])
                        }
                    }else{
                        if(
                        (co[i]['role'].indexOf('Ocean export Coordination') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                        (co[i]['role'].indexOf('Ocean Import Coordination') != -1 && (imp_exp=="" || imp_exp=="Import")) ||
                        (co[i]['role'].indexOf('Ocean export Documentation') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                        (co[i]['role'].indexOf('Ocean Import Documentation') != -1 && (imp_exp=="" || imp_exp=="Import"))){
                            toIds.push(co[i]["_id"])
                        }
                    }
                }
                if(toIds.includes(taskStore.current.createdBy)){
                    to = Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b?.contract?.nomination);
                    cc = toIds
                }else{
                    to = toIds
                    cc =  Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b?.contract?.nomination);
                }
            }
            let subject 
            if(taskStore.current.actionName == 'Booking Amendment' && taskStore.current.pendingWith == 'CUSTOMER'){
                subject = `Approval Required - Booking Amendment for ${taskStore.current.bookingNum}`
                if(taskStore.current.changesRequired) subject = `Approval Required - Cost Adjustment Approval for ${taskStore.current.bookingNum}`
            }else if(taskStore.current.actionName == 'Booking Amendment' &&taskStore.current.status == 'COMPLETED') {
                subject = `Booking Amendment Completed - ${taskStore.current.bookingNum}`
                if(taskStore.current.changesRequired) subject = `Cost Adjustment Approval Completed - ${taskStore.current.bookingNum}`
            }else{
                subject = taskStore.current.bookingNum + ' // ' + taskStore.name
                if(taskStore.current.actionName == 'Booking Amendment' && taskStore.current.changesRequired) subject = taskStore.current.bookingNum + ' // ' + 'Cost Adjustment Approval'
            }
            let userlist = Utils.getCustomerService(customer,taskStore.current.createdBy)
            const doc = {
                from, to, cc, subject
            }
            if (!to) {
                if(Array.isArray(cc)){
                    doc.to = cc.join(',');
                }else{
                    doc.to = cc;
                }
                doc.cc = '';
            }
            if(!to && !cc){
                to =`pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`
              }
            let ret
            let customerService
            let relationshipManager
        try{    
            customerService = customer?.crossBorder?.customerService
            relationshipManager = customer?.crossBorder?.relationshipManager            
            Api.sendClientMailMessage(from, to, subject,cc,customerService,relationshipManager,taskStore.oldtask,userlist);
                
        }catch(e){
                console.log('ERROR IN SENDING MAIL', e.message)
            }
        }
    }
    static async sendActionTriggerMail1(task) {
        if(task && task.actionName && task.actionName.trim().length>0){
        let data = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/listuserIds`, {entityId:task.entityId,branchId:bookingsStore.current.branchId})
            let customer = data?.shEntitiesCustomer[0]?.customer;
            let b = bookingsStore.current
            let cc = Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b.contract?.nomination );
            let from = `Actions ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} ${process.env.REACT_APP_MYACTIONSEMAIL_ID.split('@')[0]+'@'+process.env.REACT_APP_ENTERPRISE_DOMAIN}>`
            let to = bookingsStore.current.blockbooking ? undefined : data.entityUserIdList.join(',')
            let subject = task.bookingNum + ' // ' + task.actionName
            let userlist = Utils.getCustomerService(customer,task.createdBy)
            const doc = {
                from, to, cc, subject
            }
            if (!to) {
                if(Array.isArray(cc)){
                    doc.to = cc.join(',');
                }else{
                    doc.to = cc;
                }                
                doc.cc = '';
            }
            if(!to && !cc){
                to = `pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`
              }
            let ret
            let customerService
            let relationshipManager
        try{    
            customerService = customer?.crossBorder?.customerService
            relationshipManager = customer?.crossBorder?.relationshipManager 
            Api.sendClientMailMessage(from, to, subject,cc,customerService,relationshipManager,task,userlist);
                
        }catch(e){
                console.log('ERROR IN SENDING MAIL', e.message)
            }
        }
    }

    static async sendActionAgragaTriggerEmail() {
        let actionName = taskStore.name
        let b = bookingsStore.current
        let branch = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/branch/${b.branchId}`)
        let ename = await MonApi.apost(GET_SH_ENTITIES_SORTED_BY_NAME_URI, {
  "_id": taskStore.current.entityId
})
        if(ename.length>0){
            ename = ename[0]['entityName']
        }
        let country = ""
        if(branch.data){
            country = branch.data.country.toLowerCase()
        }
        if(b?.contract){
            let contract = b?.contract
            let st = contract.shipmentType
            let st1 = st.substr(0, 3).toUpperCase()
        
            let por = contract.portOfReceipt.toLowerCase()
            let fpod = contract.finalPlaceOfDelivery.toLowerCase()
            if (st1 === 'AIR') {
                por = contract.originAirport.toLowerCase()
                fpod = contract.destinationAirport.toLowerCase()
            }
            //console.log('GET ACTIONS FILTERS', por, '/', fpod, '/', country)
            let imp_exp = ''
            if(country.trim().length>0){
                if (por.indexOf(country) >= 0) imp_exp = 'Export'
                else if (fpod.indexOf(country) >= 0) imp_exp = 'Import'
            }
        let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/sendclientactionmail`
        let co = await Taskapi.getEmailsCenterlOperations(b.entityId , contract.hazardous)
        let to = []
        for (let i = 0; i < co.length; i++) {
            if(taskStore.current.shipmentType.toLowerCase().indexOf('air')!=-1){
                if(
                (co[i]['role'].indexOf('Air export Coordination') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                (co[i]['role'].indexOf('Air Import Coordination') != -1 && (imp_exp=="" || imp_exp=="Import")) ||
                (co[i]['role'].indexOf('Air export Documentation') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                (co[i]['role'].indexOf('Air Import Documentation') != -1 && (imp_exp=="" || imp_exp=="Import"))){
                    to.push(co[i]["_id"])
                }
            }else{
                if(
                (co[i]['role'].indexOf('Ocean export Coordination') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                (co[i]['role'].indexOf('Ocean Import Coordination') != -1 && (imp_exp=="" || imp_exp=="Import")) ||
                (co[i]['role'].indexOf('Ocean export Documentation') != -1 && (imp_exp=="" || imp_exp=="Export")) ||
                (co[i]['role'].indexOf('Ocean Import Documentation') != -1 && (imp_exp=="" || imp_exp=="Import"))){
                    to.push(co[i]["_id"])
                }
            }
        }
        if(to.length==0){
            to.push(`pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)
        }
        if(taskStore.current.createdBy!=undefined && taskStore.current.createdBy != `openapi@${process.env.REACT_APP_ENTERPRISE_DOMAIN}` && taskStore.current.createdBy.indexOf(process.env.REACT_APP_ENTERPRISE_DOMAIN) != -1){
            to.push(taskStore.current.createdBy)
        }
        let data = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/listuserIds`, {entityId:taskStore.current.entityId,branchId:bookingsStore.current.branchId})
            let customer = data?.shEntitiesCustomer[0]?.customer;
            let RmEmails = Utils.getRelationShipMangerForType(customer.crossBorder.relationshipManagers , b.contract.shipmentType, b.contract.tradeType , b.contract.nomination)
           let CsEmails = Utils.getCustomerServiceForType(customer.crossBorder.customerService , b.contract.shipmentType, b.contract.tradeType , b.contract.nomination)
            let cc = Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b?.contract?.nomination);
            let userlist = {}
            if(['Update Cost','Approval for loss'].indexOf(actionName)==-1){
                userlist = Utils.getCustomerService(customer,taskStore.current.createdBy)
            }
            let from = `Actions ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} ${process.env.REACT_APP_MYACTIONSEMAIL_ID.split('@')[0]+'@'+process.env.REACT_APP_ENTERPRISE_DOMAIN}>`
            to = to.join(',')
            if(taskStore.name === 'Payment Details'&& taskStore.current.isFullPayment==='No'){
                let finance = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/common/executequery/Agusers`,{filter:{department:'Finance',status:'ACTIVE'},project:{email:1}})
                to = b.blockbooking ? '' : finance.map(e=>e.email).join(",") 
            }
            let subject = `${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking ID ` + taskStore.current.bookingNum + ' | ' + actionName
            let message
            if(taskStore.current.isFullPayment==='Yes'&&taskStore.current.actionName==='Payment Details'){
                const data = await MonApi.apost(GET_MYACTIONS_PAYMENT_DETAILS_PENDING_URI, {})
                if(data.length >0){
                    message = `<p>This is to confirm that Payment has been received in full from the customer against Below Invoice number, and Finance has verified the same.</p>
                    <ol>
                        ${taskStore.current.files
                            .map(document => `<li>${document.invoiceNo} | ${Utils.formatDateForMail(document.invoiceDate)}</li>`)
                            .join('')}
                    </ol>
                    <p>Please note still payment is pending against the below invoices.</p>
                    <ol>
                        ${data
                            .flatMap(e => e.files.map(document => `<li>${document.invoiceNo} | ${Utils.formatDateForMail(document.invoiceDate)}</li>`))
                            .join('')}
                    </ol>`;
                }else{
                    message = `<p>This is to confirm that Payment has been received in full from the customer against Below Invoice number, and Finance has verified the same.</p>
                    <ol>
              ${taskStore.current.files
              .map(document => `<li>${document.invoiceNo} | ${Utils.formatDateForMail(document.invoiceDate)}</li>`).join('')}
             </ol>`
                if (taskStore.current.isFullPayment === 'Yes' && taskStore.current.actionName === 'Payment Details' && taskStore.current.method == 'Razorpay'){
                    message +=`<p>Payment has been made through Razorpay.</p>`
                }
            }
            }else{
                const list = ['BL Draft Approval', 'AWB Draft Approval', 'Cost Adjustment Approval', 'Invoice Acceptance', 'Shipping Bill Checklist Approval', 'Bill of Entry Checklist Approval', 'Schedule Change Approval', 'Booking Amendment', 'Entry Summary Approval', 'Proforma Invoice Approval']
                if(list.includes(actionName)){
                    if((taskStore.current.files.some((e)=>e.approved == 'Reject') && taskStore.current.actionName !== 'Proforma Invoice Approval') || taskStore.current.stageStatus =='Reject'){
                        subject = 'Rejected // ' + taskStore.current.bookingNum + ' // ' + actionName
                        if(actionName == 'Booking Amendment' && taskStore.current.changesRequired) subject = 'Rejected // ' + taskStore.current.bookingNum + ' // ' + 'Cost Adjustment Approval'
                        message = `<p>The <strong>${actionName}</strong> against Booking Number ${taskStore.current.bookingNum} has been <strong>Rejected</strong>. Due to </p>`
                        if(taskStore.current.stageStatus =='Reject'){
                            message += `${taskStore.current.rejectReason}`
                        }else{
                            message += `<ol>
                            ${taskStore.current.files
                                .filter(document => document.rejectReason)
                                .map(document => `<li>${document.rejectReason}</li>`)
                                .join('')}
                            </ol>`
                        }
                        if (taskStore.current.actionName == 'Entry Summary Approval') {
                            message += `<strong>Customer Name:</strong> ${ename}</br>
                                <strong>Branch Name:</strong> ${branch?.data?.state}</br>
                                <strong>Origin:</strong> ${taskStore.current.origin}</br>`
                            if (b.contract.multidest.length > 1) {
                                message += `${b.contract.multidest.map((e, i) => `<strong>Destination ${i + 1}:</strong> ${Utils.getCountry(e.destination).split(',')[1]}</br>`).join('')}`
                            } else {
                                message += `<strong>Destination:</strong> ${taskStore.current.destination}</br>`
                            }
                            if (RmEmails && RmEmails[0]?.email?.length > 0) {
                                const rmData = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${RmEmails[0]?.email}`)
                                message += `<strong>Relationship Manager:</strong> ${rmData?.firstName + " " + rmData?.lastName + "(" + rmData.email + ',' + rmData?.phone + ")"}</br>`
                            }
                            if (CsEmails && CsEmails[0]?.email?.length > 0) {
                                const csData = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${CsEmails[0]?.email}`)
                                message += `<strong>Customer Service:</strong> ${csData?.firstName + " " + csData?.lastName + "(" + csData.email + ',' + csData?.phone + ")"}</br>`
                            }
                            message += `<strong>FBA:</strong> ${b.fba}</br>
                                <strong>Completed By:</strong> ${loginStore.email}</p>`
                        }
                        message += `<p>Please <strong><a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${actionName}">Click Here</a></strong> to check and re-initiate the same.</p>`
                    } else if (taskStore.current.actionName === "Proforma Invoice Approval" && taskStore.current.stage == 3 ) {
                        subject = `Proforma Freight Invoice Approved - ${taskStore.current.bookingNum}`
                        message =  `
                            <p>Hi Team,</p>

                            <p>
                                The customer has <strong style="color: #218838;">approved</strong>
                                the Proforma Freight Invoice. Please proceed with generating the
                                <strong>Final Freight Invoice</strong>.
                            </p>

                            <table style="width: 100%; max-width: 600px; border-collapse: collapse; margin: 15px 0;">
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold; width: 40%;">
                                        ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.bookingNum}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Proforma Invoice Number
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.files?.find(e => e.label === "Proforma Invoice")?.invoiceNo}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Approved By
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${loginStore.email}
                                    </td>
                                </tr>
                            </table>

                            <p>
                                Please ensure the Final Freight Invoice is raised accordingly.
                            </p>

                            <p>
                                Best regards,<br/>
                                <strong>Product Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</strong>
                            </p>`
                    } else if (taskStore.current.actionName === "Proforma Invoice Approval" && taskStore.current.stage == 2 && taskStore.current.files.some((e) => e.approved == 'Reject')) {
                        subject = `Proforma Freight Invoice Rejected  - ${taskStore.current.bookingNum}`
                        message = `

                            <p>Hi Team,</p>

                            <p>
                                The customer has <strong style="color: #dc3545;">rejected</strong>
                                the Proforma Freight Invoice. Please review the details below and take
                                the necessary action.
                            </p>

                            <table style="width: 100%; max-width: 600px; border-collapse: collapse; margin: 15px 0;">
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold; width: 40%;">
                                        ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.bookingNum}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Proforma Invoice Number
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.files?.find((e) => e.label === "Proforma Invoice")?.invoiceNo}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Rejection Reason
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.files[0]?.rejectReason}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Rejected By
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.rejectedBy}
                                    </td>
                                </tr>
                            </table>

                            <p>
                                Please make the necessary corrections and
                                <strong>resubmit the Proforma Freight Invoice</strong> for approval.
                            </p>

                            <p>
                                Best regards,<br/>
                                <strong>Product Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</strong>
                            </p>`
                    } else if (taskStore.current.actionName === "Proforma Invoice Approval" && taskStore.current.stage == 4 && taskStore.current.status == "COMPLETED") {
                        subject = `Freight Invoice Raised - ${taskStore.current.bookingNum}`
                        if(TenantUtils.isNavexel()){
                            to = cc
                            cc = ''
                        }
                        message = `
                            <p>Dear Sir/Madam,</p>

                            <p>Greetings from <strong>${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</strong>!</p>

                            <p>
                                This is to inform you that the <strong>invoice has been raised</strong>
                                against your shipment. Please find the details below.
                            </p>

                            <table style="width: 100%; max-width: 600px; border-collapse: collapse; margin: 15px 0;">
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold; width: 40%;">
                                        ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Reference
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.bookingNum}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Invoice Number
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.files?.find(e => e.label === "Freight Invoice")?.invoiceNo}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Invoice Date
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.files?.find(e => e.label === "Freight Invoice")?.invoiceDate}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                        Invoice Amount
                                    </td>
                                    <td style="padding: 10px; border: 1px solid #dddddd;">
                                        ${taskStore.current.currency[0]?.totalAmount} ${taskStore.current.currency[0]?.currencyType}
                                    </td>
                                </tr>
                            </table>

                            <p>
                                The invoice is attached for your reference. You can also view the invoice
                                and shipment details on the ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} platform:
                            </p>

                            <p>
                                <a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${taskStore.current.actionName}">
                                    View Invoice
                                </a>
                            </p>

                            <p>
                                Kindly refer to the invoice for the applicable
                                <strong>payment terms and due date</strong>.
                            </p>

                            <p>
                                Thank you for choosing ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}. We appreciate your continued trust and support.
                            </p>

                            <p>
                                Best regards,<br/>
                                <strong>Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</strong>
                            </p>`
                    } else if(taskStore.current.actionName == 'Booking Amendment' && taskStore.current.stageStatus =='Approve' ){
                       Taskapi.sendActionTriggerMail()
                       return
                    }else{
                        subject = 'Approved // ' + taskStore.current.bookingNum + ' // ' + actionName
                        message = `<p>The <strong>${actionName}</strong> against Booking Number ${taskStore.current.bookingNum} has been <strong>Approved</strong>.</p>`
                        if (taskStore.current.actionName == 'Entry Summary Approval'){
                                message += `<strong>Customer Name:</strong> ${ename}</br>
                                <strong>Branch Name:</strong> ${branch?.data?.state}</br>
                                <strong>Origin:</strong> ${taskStore.current.origin}</br>`
                                if (b.contract.multidest.length > 1) {
                                    message += `${b.contract.multidest.map((e, i) => `<strong>Destination ${i + 1}:</strong> ${Utils.getCountry(e.destination).split(',')[1]}</br>`).join('')}`
                                } else {
                                    message += `<strong>Destination:</strong> ${taskStore.current.destination}</br>`
                                }
                                if (RmEmails && RmEmails[0]?.email?.length > 0) {
                                    const rmData = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${RmEmails[0]?.email}`)
                                    message += `<strong>Relationship Manager:</strong> ${rmData?.firstName + " " + rmData?.lastName + "(" + rmData.email + ',' + rmData?.phone + ")"}</br>`
                                }
                                if (CsEmails && CsEmails[0]?.email?.length > 0) {
                                    const csData = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${CsEmails[0]?.email}`)
                                    message += `<strong>Customer Service:</strong> ${csData?.firstName + " " + csData?.lastName + "(" + csData.email + ',' + csData?.phone + ")"}</br>`
                                }
                                message += `<strong>FBA:</strong> ${b.fba}</br>
                                <strong>Completed By:</strong> ${loginStore.email}</p>` 
                        }     
                        message += `<p>Please <strong><a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${actionName}">Click Here</a></strong> to check and re-initiate the same.</p>`
                    }
                }else if(actionName == "Visibility Update" && taskStore.current.status === "PENDING"){
                    to = Utils.getCentralOpsbasedOnSubrole(co, taskStore.current.visibilityUpdateTrigger, por, fpod)
                    if (to.length == 0) to.push(`pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)
                    subject = taskStore.current.bookingNum + ' // ' + taskStore.name 
                    message = `
                        <p>We have a new Action for you!</p>
                        <p>Please <strong><a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${taskStore.name}">Click Here</a></strong> to view and complete</p>
                        <br/><br/>
                        <p>Thank You</p>
                        <p><strong>Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</strong></p>`
                }else if(actionName=='Update Cost' && taskStore.current.stage==1){
                    if(!b.blockbooking){
                        to = Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b?.contract?.nomination);
                        to = to.split(',')
                        if(b['contract']['procurement']!=undefined && b['contract']['procurement'].length>0){
                            to.push(b['contract']['procurement'])
                        }
                        to = to.join(',')
                    }
                    cc = ''
                    subject = `Action Required: Complete Cost Update for ${taskStore.current.bookingNum}`
                    message = `<p>
    Dear Team,<br>
    Please complete the Update cost My Action for the shipment mentioned below:<br>
    Shipment Details:<br>
    • ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Ref: ${taskStore.current.bookingNum}<br>
    • Customer: ${ename}<br>
    • Mode: ${taskStore.current.shipmentType}<br>
    Action Required:Update the cost.<br>
    <a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${actionName}">Click here</a> to complete the action<br>
    Regards,<br>
    Product Team<br>
    ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}
</p>`
                }else if(actionName=='Approval for loss' && taskStore.current.approve==false){
                    subject = `Hold Processing for ${taskStore.current.bookingNum} - Loss Approval Rejected Approved`
                    message = `<p>
    <span data-teams="true">Please put the processing of the shipment with <strong>Booking ID: ${taskStore.current.bookingNum}</strong> on immediate hold.</span>
</p>
<p>
    <span data-teams="true">Kindly do not proceed further with this booking until further notice.</span>
</p>
<p>Please <strong><a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${actionName}">Click Here</a></strong>.
<p>
    &nbsp;
</p>
<p>
    <span data-teams="true">Thanks</span>
</p>
<p>
    <span data-teams="true">Product Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</span>
</p>`
                }else if((actionName=='Approval for loss' || actionName=='Update Cost') && taskStore.current.approve==true){
                    subject = `Cost Updated for ${taskStore.current.bookingNum} - Please Process Shipment`
                    message = `
<p>
    Dear Central Ops Team,<br>
    The cost has been successfully updated by the team for the following shipment:<br>
    Shipment Details:<br>
    • ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Booking Ref: ${taskStore.current.bookingNum}<br>
    • Customer: ${ename}<br>
    • Mode: ${taskStore.current.shipmentType}<br>
    Action: Cost updated. Kindly proceed with the shipment processing.&nbsp;<br>
    <a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${actionName}">Click here</a> to see the cost.<br>
    Regards,<br>
    Product Team<br>
    ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}
</p>`
                }else{
                    message = `<p>Customer has completed a <strong>${actionName}</strong>. Please check and confirm.</p>
                    <strong>Customer Name:</strong> ${ename}</br>
                    <strong>Branch Name:</strong> ${branch?.data?.state}</br>
                    <strong>Origin:</strong> ${taskStore.current.origin}</br>`
                    if(b.contract.multidest.length>1){
                        message+= `${b.contract.multidest.map((e,i) =>`<strong>Destination ${i+1}:</strong> ${Utils.getCountry(e.destination).split(',')[1]}</br>`).join('')}`
                    }else{
                        message+=`<strong>Destination:</strong> ${taskStore.current.destination}</br>`
                    }
                    if(RmEmails && RmEmails[0]?.email?.length > 0){
                        const rmData = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${RmEmails[0]?.email}`)  
                        message+=`<strong>Relationship Manager:</strong> ${rmData?.firstName+" "+rmData?.lastName+"("+rmData.email+','+rmData?.phone+")"}</br>`
                    }
                    if(CsEmails && CsEmails[0]?.email?.length > 0){
                        const csData = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${CsEmails[0]?.email}`)          
                        message+=`<strong>Customer Service:</strong> ${csData?.firstName+" "+csData?.lastName+"("+csData.email+','+csData?.phone+")"}</br>`
                    }
                    message+=`<strong>FBA:</strong> ${b.fba}</br>
                              <strong>Completed By:</strong> ${loginStore.email}</p>`
                }
            }
            if(EntityV2Store.EntityRec?.customer?.crossBorder?.salesVertical?.trim() == 'MSME' && b?.contract?.customerReferenceNum) subject = subject+'// CRN: '+ b?.contract?.customerReferenceNum
            const doc = {
                from, to, cc, subject, message, userlist, bookingNum:taskStore.current.bookingNum
            }
            if (!to) {
                if(Array.isArray(cc)){
                    doc.to = cc.join(',');
                }else{
                    doc.to = cc;
                }
                doc.cc = '';
            }
            if(!to && !cc){
                to = `pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`
              }
            let ret
        try{    
                if (doc.to){
                ret = await MonApi.apost(url, doc)
                }
        }catch(e){
                console.log('ERROR IN SENDING MAIL', e)
            }
        console.log('return from sending mail=',ret)
        }
            //configStore.setModalMessage(`Email sent to ${ret.message.accepted}`)
    }

    static async sendRazorpayMail(task) {
        if(task && task.actionName && task.actionName.trim().length>0){
        let data = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/listuserIds`, {entityId:task.entityId,branchId:bookingsStore.current.branchId})
            let customer = data?.shEntitiesCustomer[0]?.customer;
            let b = bookingsStore.current
            let cc = Utils.getRespectiveMember(customer,b?.contract?.shipmentType,b?.contract?.tradeType , b.contract?.nomination );
            let from = `${process.env.REACT_APP_SUPPORT_MAIL_ID.split('@')[0]+'@'+process.env.REACT_APP_ENTERPRISE_DOMAIN}>`
            let to = bookingsStore.current.blockbooking ? undefined : data.entityUserIdList.join(',')
            let subject = `Payment Received Successfully - Invoice No:${task.files[0]?.invoiceNo}` 
            let userlist = Utils.getCustomerService(customer,task.createdBy)
            const doc = {
                from, to, cc, subject
            }
            if (!to) {
                if(Array.isArray(cc)){
                    doc.to = cc.join(',');
                }else{
                    doc.to = cc;
                }                
                doc.cc = '';
            }
            if(!to && !cc){
                to = `pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`
              }
            let ret
            let customerService
            let relationshipManager
        try{    
            customerService = customer?.crossBorder?.customerService
            relationshipManager = customer?.crossBorder?.relationshipManager 
            Api.sendClientMailMessage(from, to, subject,cc,customerService,relationshipManager,task,userlist);
                
        }catch(e){
                console.log('ERROR IN SENDING MAIL', e.message)
            }
        }
    }

    static async sendActionAutoTriggerEmail(actionList) {
        if (actionList.actionName && actionList.actionName.trim().length > 0) {
            let url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/sendclientactionmail`
            let data = await MonApi.apost(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/listuserIds`, { entityId: taskStore.current.entityId, branchId: bookingsStore.current.branchId })
            let customer = data?.shEntitiesCustomer[0]?.customer;
            let b = bookingsStore.current
            let cc = Utils.getRespectiveMember(customer, b?.contract?.shipmentType, b?.contract?.tradeType, b?.contract.nomination);
            let userlist = Utils.getCustomerService(customer, taskStore.current.createdBy)
            let from = `Actions ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} ${process.env.REACT_APP_MYACTIONSEMAIL_ID.split('@')[0] + '@' + process.env.REACT_APP_ENTERPRISE_DOMAIN}>`
            let to = bookingsStore.current.blockbooking ? undefined : data.entityUserIdList.join(',')
            let subject = ` Approval Required: Proforma Invoice Approval - ${taskStore.current.bookingNum}`
            if (customer?.crossBorder?.salesVertical?.trim() == 'MSME' && b?.contract?.customerReferenceNum) subject = subject + '// CRN: ' + b?.contract?.customerReferenceNum
            let message = `
                    <p>Dear Sir/Madam,</p>
                    <p>Greetings from Agraga!</p>
                    <p>
                        Please find attached the Proforma Freight Invoice against the booking below
                        for your review and approval.
                    </p>

                    <table style="width: 100%; max-width: 600px; border-collapse: collapse; margin: 15px 0;">
                        <tr>
                            <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold; width: 40%;">
                                Agraga Booking Reference
                            </td>
                            <td style="padding: 10px; border: 1px solid #dddddd;">
                                ${taskStore.current.bookingNum}
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                Requirement Type
                            </td>
                            <td style="padding: 10px; border: 1px solid #dddddd;">
                                Approval for Proforma Freight Invoice
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                Origin
                            </td>
                            <td style="padding: 10px; border: 1px solid #dddddd;">
                                ${taskStore.current.por}
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                Destination
                            </td>
                            <td style="padding: 10px; border: 1px solid #dddddd;">
                                ${taskStore.current.fpod}
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 10px; border: 1px solid #dddddd; background-color: #f5f5f5; font-weight: bold;">
                                Shipment Type
                            </td>
                            <td style="padding: 10px; border: 1px solid #dddddd;">
                                ${taskStore.current.shipmentType}
                            </td>
                        </tr>
                    </table>

                    <p>
                        Kindly review the invoice and reply to this email with your confirmation.
                        If any corrections are required, please share the details so that we can
                        make the necessary changes promptly.
                    </p>

                    <p>
                        <strong>Please note:</strong> If we do not receive a response within
                        1 calendar day, the invoice will be deemed accepted and payable in
                        accordance with our agreed payment terms.
                    </p>

                    <p>
                        You can also review and approve the invoice on the Agraga platform:
                    </p>

                <p>
                    <a href="<<server>>/myactions/${taskStore.current.bookingNum}ACTLINGACT${actionList.actionName}">
                        View &amp; Approve Invoice
                    </a>
                </p>

                <p>Thank you for your valuable support!</p>

                <p>
                    Best regards,<br/>
                    Team ${process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}
                </p>`
            if (TenantUtils.isNavexel()) {
                to = cc
                cc = ''
            }
            const doc = {
                from, to, cc, subject, message, userlist, bookingNum: taskStore.current.bookingNum
            }
            if (!to) {
                if (Array.isArray(cc)) {
                    doc.to = cc.join(',');
                } else {
                    doc.to = cc;
                }
                doc.cc = '';
            }
            if (!to && !cc) {
                to = `pat@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`
            }
            let ret
            try {
                if (doc.to) {
                    ret = await MonApi.apost(url, doc)
                }
            } catch (e) {
                console.log('ERROR IN SENDING MAIL', e)
            }
            console.log('return from sending mail=', ret)
            //configStore.setModalMessage(`Email sent to ${ret.message.accepted}`)
        }
    }

    static async getbookingdsr(bookingid) {
        let ret = await MonApi.apost(GET_BOOKINGDSR_BY_FILTER_URI, {
  'agraga_booking_#': bookingid
})
        return ret
    }
}

export {
    Task
}